import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-48fbc784"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "title" };
const _hoisted_2 = { class: "wrapper" };
const _hoisted_3 = ["onClick"];
import { reactive, inject } from 'vue';
import Alert from '@/materials/atoms/Alert.vue';
import MessageList from './MypageMessage/MessageList.vue';
import { useNotification } from '@/logics/notification';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        displayTitle: null
    },
    setup(__props) {
        const props = __props;
        const toast = inject('toast');
        const { unreadCount, getNotifications, readAllNotification, readNotification, deleteNotification } = useNotification();
        const state = reactive({});
        const { MYPAGE_MESSAGE, format } = useMessage();
        const initialize = () => __awaiter(this, void 0, void 0, function* () {
            state.notifications = yield getNotifications();
        });
        const onClickReadAll = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield readAllNotification();
            !!((_a = state.notifications) === null || _a === void 0 ? void 0 : _a.data) && state.notifications.data.forEach((n) => (n.read = true));
            toast.success(format(MYPAGE_MESSAGE.SUCCESS_READ_ALL_API));
        });
        const onClickDelete = ({ notification }) => __awaiter(this, void 0, void 0, function* () {
            var _b;
            if (!confirm(format(MYPAGE_MESSAGE.CONFIRM_DELETE)))
                return;
            yield deleteNotification(notification.id);
            !!((_b = state.notifications) === null || _b === void 0 ? void 0 : _b.data) &&
                (state.notifications.data = state.notifications.data.filter((n) => n.id != notification.id));
            toast.success(format(MYPAGE_MESSAGE.SUCCESS_DELETE_API));
        });
        const onClickMore = () => __awaiter(this, void 0, void 0, function* () {
            var _c, _d;
            if (!((_c = state.notifications) === null || _c === void 0 ? void 0 : _c.meta.cursor))
                return;
            const notifications = yield getNotifications((_d = state.notifications) === null || _d === void 0 ? void 0 : _d.meta.cursor);
            state.notifications.data.push(...notifications.data);
            state.notifications.meta = notifications.meta;
        });
        const onClickRead = ({ notification }) => __awaiter(this, void 0, void 0, function* () {
            yield readNotification(notification.id);
            notification.read = true;
        });
        initialize();
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(props.displayTitle)), 1)
                ]),
                _createElementVNode("div", _hoisted_2, [
                    (_unref(unreadCount) > 0)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            class: "link",
                            onClick: _withModifiers(onClickReadAll, ["prevent"])
                        }, _toDisplayString(_unref(format)(_unref(MYPAGE_MESSAGE).LINK_READ_ALL)), 9, _hoisted_3))
                        : _createCommentVNode("", true),
                    (_unref(state).notifications)
                        ? (_openBlock(), _createBlock(MessageList, {
                            key: 1,
                            notifications: (_a = _unref(state).notifications) === null || _a === void 0 ? void 0 : _a.data,
                            cursor: (_c = (_b = _unref(state).notifications) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.cursor,
                            onClickRead: onClickRead,
                            onClickDelete: onClickDelete,
                            onClickMore: onClickMore
                        }, null, 8, ["notifications", "cursor"]))
                        : _createCommentVNode("", true)
                ]),
                (_unref(state).notifications && _unref(state).notifications.data.length === 0)
                    ? (_openBlock(), _createBlock(Alert, {
                        key: 0,
                        "color-mode": "warning"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(format)(_unref(MYPAGE_MESSAGE).ALERT_NOT_FOUND_MESSAGE)), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
